<template>
  <transition :name="transition">
    <div
      v-if="visible"
      ref="overlay"
      :class="['sf-overlay']"
      v-bind="$attrs"
      @click="$emit('click', $event)"
    />
  </transition>
</template>
<script>

export default {
  name: 'SfOverlay',
  props: {
    transition: {
      type: String,
      default: 'sf-fade',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
};

</script>
<style lang="scss">
.sf-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: var(--overlay-z-index, 1);
  background: var(--overlay-background, rgba(var(--c-gray-base), 0.7));
}
</style>
